import type { Dispatch } from '@avalara/types/actions';
import type { Result } from '@avalara/types/index';

import conf from '../../conf';
import fetch from '../fetch';

// Contract with PF-8565/PF-8567: the server does lead capture + user provisioning + magic
// link generation in one call, and always returns a single URL to redirect the browser to -
// either the Identity magic link on success, or a logout redirect to run before retrying, for
// an existing non-Crush session.
export type AviatorCrushSignupRequest = {
  firstName: string;
  lastName: string;
  email: string;
  /** From the landing URL's `crushPrompt` query param (PF-8767); omitted when absent. */
  crushPrompt?: string;
  // Set when this submission was driven by a returning-attendee lead cookie (PF-8766) rather
  // than a freshly typed form, so the server can skip re-sending the lead to MILES.
  isReturningAttendee?: boolean;
};

export type AviatorCrushSignupResponse = { redirectUrl: string };

export const submitAviatorCrushSignup = (
  dispatch: Dispatch,
  body: AviatorCrushSignupRequest,
): Promise<Result<AviatorCrushSignupResponse>> =>
  fetch(dispatch, { showLoadingWheel: false })<AviatorCrushSignupResponse>(`${conf.API_URL}/api/aviator-crush/signup`, {
    method: 'POST',
    body: JSON.stringify(body),
  });
